import generateRequest from "./generateRequest";

const request = generateRequest("friend");
const openReq = generateRequest("v1", process.env.VUE_APP_OPEN_SERVER);

export function getInfo(params) {
  return request("getInfo", params);
}

export function saveAnswer(params) {
  return request("saveAnswer", params, { method: "POST" });
}

export function uploadAudio(params) {
  return openReq("upload/audio", params, {
    noStatusCode: true,
    dataType: "form",
    method: "PUT"
  });
}

export function getLiveInfo(params) {
  return request("getLiveInfo", params);
}

export function saveLive(params) {
  return request("saveLive", params, { method: "POST" });
}
